import { render, staticRenderFns } from "./wtMastheadLikeHeader.component.vue?vue&type=template&id=5541feae&"
import script from "./wtMastheadLikeHeader.component.vue?vue&type=script&lang=js&"
export * from "./wtMastheadLikeHeader.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports